import { eTipoPermissao } from '@/enums/ePermissoes';
export default [
  {
    description: 'Gestão de Parâmetros',
    path: '/gesparametros',
    name: 'gesparametros',
    component: () => import('@/views/gesparametros/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.GESTAO_PARAMETROS],
    },
    goesToMenu: true,
  },
  {
    description: 'Editar Parâmetro',
    path: '/gesparametros/cadastro/:id?',
    parent: 'gesparametros',
    name: 'gesparametros_create',
    component: () => import('@/views/gesparametros/components/InclusaoEdicao.vue'),
    meta: {
      permissions: [eTipoPermissao.GESTAO_PARAMETROS],
    },
    goesToMenu: true,
  },
];
